import { formatMoney } from 'global';

class EmaBuildBundle extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    this.items = [...this.querySelectorAll('[data-ema-bundle-item]')];
    if (!this.items.length) return;
    this.countEl = this.querySelector('[data-ema-count]');
    this.fillEl = this.querySelector('[data-ema-progress]');
    this.priceEl = this.querySelector('[data-ema-total]');
    this.compareEl = this.querySelector('[data-ema-compare]');
    this.savingEl = this.querySelector('[data-ema-saving]');
    this.submitEl = this.querySelector('[data-ema-submit]');
    this.countTemplate = this.dataset.countTemplate || '[count] of [total] picked';
    this.savingTemplate = this.dataset.savingTemplate || 'Saving [percent]%';
    this.twoDiscount = Number(this.dataset.twoDiscount || 10);
    this.threeDiscount = Number(this.dataset.threeDiscount || 15);
    this.minItems = Number(this.dataset.minItems || 2);
    this.moneyFormat = window.themeHDN?.settings?.currencyFormat || '';
    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    this._wired = false;
    this.removeEventListener('change', this.onChange);
  }

  onChange(event) {
    const item = event.target.closest('[data-ema-bundle-item]');
    if (!item) return;
    this.sync();
  }

  discountFor(count) {
    if (count >= 3) return this.threeDiscount;
    if (count >= 2) return this.twoDiscount;
    return 0;
  }

  sync() {
    let count = 0;
    let subtotal = 0;

    this.items.forEach((item) => {
      const toggle = item.querySelector('[data-ema-toggle]');
      const checked = Boolean(toggle && toggle.checked);
      item.classList.toggle('is-selected', checked);
      item.querySelectorAll('[data-ema-field]').forEach((field) => {
        field.disabled = !checked;
      });
      if (checked) {
        count += 1;
        subtotal += Number(item.dataset.price || 0);
      }
    });

    const totalItems = this.items.length;
    const percent = this.discountFor(count);
    const discounted = percent ? Math.round((subtotal * (100 - percent)) / 100) : subtotal;

    if (this.countEl) {
      this.countEl.textContent = this.countTemplate
        .replace('[count]', String(count))
        .replace('[total]', String(totalItems));
    }

    if (this.fillEl) {
      const width = totalItems ? (count / totalItems) * 100 : 0;
      this.fillEl.style.width = `${width}%`;
    }

    if (this.priceEl) {
      this.priceEl.innerHTML = formatMoney(discounted, this.moneyFormat);
    }

    if (this.compareEl) {
      const showCompare = percent > 0 && subtotal > discounted;
      this.compareEl.toggleAttribute('hidden', !showCompare);
      if (showCompare) this.compareEl.innerHTML = formatMoney(subtotal, this.moneyFormat);
    }

    if (this.savingEl) {
      const showSaving = percent > 0 && count > 0;
      this.savingEl.toggleAttribute('hidden', !showSaving);
      if (showSaving) {
        this.savingEl.textContent = this.savingTemplate.replace('[percent]', String(percent));
      }
    }

    if (this.submitEl) {
      this.submitEl.disabled = count < this.minItems;
    }

    document.dispatchEvent(new CustomEvent('currency:update'));
  }
}

if (!customElements.get('ema-build-bundle')) {
  customElements.define('ema-build-bundle', EmaBuildBundle);
}
